import { render, staticRenderFns } from "./ContentApp.vue?vue&type=template&id=618a5576"
import script from "./ContentApp.vue?vue&type=script&lang=js"
export * from "./ContentApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports